import get from 'lodash/get'
import { Controller, useFormContext } from 'react-hook-form'

import { Component } from './components/Component'

import type { SelectProps } from './types'

export const Select = ({
  name,
  label,
  placeholder,
  required,
  options,
  error,
  hasController = true,
  ...rest
}: SelectProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Component
            name={name}
            label={label}
            placeholder={placeholder}
            required={required}
            options={options}
            error={get(errors, name)?.message as string}
            value={field.value}
            onChange={field.onChange}
            {...rest}
          />
        )}
      />
    )
  }

  return (
    <Component
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      options={options}
      error={error}
      {...rest}
    />
  )
}
